// extracted by mini-css-extract-plugin
export default {"lds-dual-ring":"Preloader_lds-dual-ring__Ns3eK","lds-dual-ring--small":"Preloader_lds-dual-ring--small__7G7YF"};